import { VariableType } from 'json-to-graphql-query';
export const MailReportErrorInputVariables = {
    reportErrorInput: 'MailReportErrorInput!'
};
export const MailReportErrorInputArgs = {
    reportErrorInput: new VariableType('reportErrorInput')
};
//# sourceMappingURL=mail.js.map